<template>
  <div v-if="!!phaseData && !loading">
    <field-label label="Quando iniciaram os sintomas?" class="mt-6">
      <v-row>
        <v-col cols="12" sm="4">
          <v-menu
            ref="pickStartDate"
            v-model="pickStartDate"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                :value="
                  phaseData.symptomsStartDate
                    ? $moment(phaseData.symptomsStartDate).format('DD/MM/YYYY')
                    : 'Clique para selecionar'
                "
                solo
                v-bind="attrs"
                v-on="on"
                class="mt-3"
              />
            </template>
            <v-date-picker
              v-model="phaseData.symptomsStartDate"
              no-title
              @change="pickStartDate = false"
              locale="pt-br"
              :max="$moment().subtract(1, 'days').toISOString()"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
    </field-label>
    <field-label label="De acordo com o seu atendimento, o paciente tem diagnóstico de Espondiloartrite?" class="mt-6">
      <v-row>
        <v-col cols="12">
          <radio-options
            :options="defaultOptions"
            v-model="phaseData.diagnosisValue"
            :row="$vuetify.breakpoint.smAndUp"
          />
        </v-col>
      </v-row>
    </field-label>
    <field-label label="Você solicitou exames?" class="mt-6">
      <v-row>
        <v-col cols="12" class="pb-0">
          <radio-options
            :options="defaultBooleanOptions"
            v-model="phaseData.hasExams"
            :row="$vuetify.breakpoint.smAndUp"
          />
        </v-col>
        <v-col class="pt-0 ml-4" v-if="phaseData.hasExams">
          <search-server-field
            v-model="phaseData.exams"
            :cacheItems="true"
            multiple
            required
            label="Quais?"
            path="exam"
            class="pa-0"
          />
        </v-col>
      </v-row>
    </field-label>
    <field-label label="Você receitou algum medicamento?" class="mt-6">
      <v-row>
        <v-col cols="12" class="pb-0">
          <radio-options
            :options="defaultBooleanOptions"
            v-model="phaseData.hasMedicines"
            :row="$vuetify.breakpoint.smAndUp"
          />
        </v-col>
        <v-col class="pt-0 ml-4" v-if="phaseData.hasMedicines">
          <field-label label="Quais?">
            <v-combobox
              :items="treatments"
              :item-text="(item) => item.medicine.name"
              v-model="phaseData.medicines"
              multiple
              chips
              deletable-chips
            ></v-combobox>
          </field-label>
        </v-col>
      </v-row>
    </field-label>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')

import BasePhase from '@/components/AttendanceForm/general/phase/BasePhase.vue'
import FieldLabel from '@/components/FieldLabel.vue'
import RadioOptions from '@/components/RadioOptions.vue'
import SearchServerField from '@/components/SearchServerField.vue'
export default {
  components: { FieldLabel, RadioOptions, SearchServerField },
  extends: BasePhase,
  data() {
    return {
      treatments: null,
      error: false,
      loading: false,
      pickStartDate: false,
      defaultOptions: [
        {
          text: 'Sim',
          value: 'SIM',
        },
        {
          text: 'Não',
          value: 'NAO',
        },
        {
          text: 'Em investigação',
          value: 'EM_INVESTIGACAO',
        },
      ],
      defaultBooleanOptions: [
        {
          text: 'Sim',
          value: true,
        },
        {
          text: 'Não',
          value: false,
        },
      ],
    }
  },
  computed: {
    ...attendanceGettersMap(['attendancePatient', 'attendanceDiseaseId']),
  },
  methods: {
    getDefaultData() {
      const data = {
        symptomsStartDate: null,
        diagnosisValue: null,
        hasExams: null,
        exams: null,
        hasMedicines: null,
        medicines: null,
      }
      return data
    },
    async loadData() {
      try {
        this.loading = true
        this.treatments = (await this.$api.getTreatmentsForDisease(this.attendanceDiseaseId)).items
        this.error = false
      } catch (error) {
        this.$root.error(error)
        this.error = true
      } finally {
        this.loading = false
      }
    },
  },
  async mounted() {
    await this.loadData()
  },
}
</script>

<style scoped></style>
